import { takeLatest, put, select, call } from "redux-saga/effects";
import { ActionTypes } from "./types";
import { snack } from "components/GlobalSnackbar";
import { failure, success } from "./actions";
import { getError, getKeyEtapas, getKeyTreeview } from "utils";
import { PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "store";
import { api, cacheDados, Environment } from "configs";
import { set as setConfiguracoes } from "store/modules/configuracoes";
import {
  EUserType,
  IConfiguracoesEducador,
  IOpcoesConfiguracoesEducador,
  IPeriodoEtapa,
  ITreeViewTurma,
} from "@deltasge/marauders-map";
import { set as setTreeView } from "store/modules/tree-view";

function* request({ payload: anoLetivo }: PayloadAction<string>) {
  try {
    const {
      usuario: { usuario },
    }: RootState = yield select();

    if (!usuario) {
      throw new Error("Erro ao encontrar o usuário autenticado");
    }

    const cache24h = 60 * 24;
    const keyEtapas = getKeyEtapas(usuario, anoLetivo);
    const keyTreeview = getKeyTreeview(usuario, anoLetivo);

    const cacheEtapas = cacheDados.get<IPeriodoEtapa[]>(keyEtapas);
    if (
      cacheEtapas &&
      typeof cacheEtapas != "string" &&
      Array.isArray(cacheEtapas)
    ) {
      yield put(setConfiguracoes({ etapas: cacheEtapas }));
    } else {
      const opcoes: Partial<IOpcoesConfiguracoesEducador> = { etapas: true };

      const { data: configuracoes } = yield call(
        api.get,
        `/educador/configuracoes/${anoLetivo}`,
        {
          clearCacheEntry: true,
          params: { opcoes },
          baseURL: `${Environment.API_URL}/api/v2/${usuario?.escolaId}`,
        }
      );
      if (configuracoes) {
        const { etapas } = configuracoes as Partial<IConfiguracoesEducador>;
        if (!etapas) {
          throw new Error("Etapas não encontradas");
        }
        yield put(setConfiguracoes({ etapas }));
        cacheDados.set(keyEtapas, etapas, cache24h);
      }
    }

    const cacheTreeview = cacheDados.get<ITreeViewTurma>(keyTreeview);
    if (
      cacheTreeview &&
      typeof cacheTreeview != "string" &&
      Object.keys(cacheTreeview).length > 0
    ) {
      yield put(setTreeView(cacheTreeview));
    } else {
      const { data: turmas } = yield call(
        api.get,
        `/turma/tree-view/${anoLetivo}`.concat(
          usuario?.tipoUsuario == EUserType.Professor
            ? `/professor/${usuario.id}`
            : ""
        )
      );
      if (turmas) {
        yield put(setTreeView(turmas as ITreeViewTurma));
        cacheDados.set(keyTreeview, turmas as ITreeViewTurma, cache24h);
      }
    }

    yield put(success());
  } catch (error) {
    yield put(failure());
    snack.error(getError(error));
  }
}
export const sagas = takeLatest([ActionTypes.REQUEST], request);
